import React from 'react'
import styles from './HostingHeader.scss'
import {__t} from '../../../common/lang/text-resource'

const HostingHeader = () => {
	const lang = SHVO.pageLang ?? 'bg';

	return (
	  <>
		  <header className={`${styles.container} ${lang === 'en' ? styles.container_en : ''}`}>
			  <div className={styles.contentHolder}>
				  <div className={`${styles.priceElement} ${lang === 'en' ? styles.priceElement_en : ''}`}>
					  <div className={styles.textHolder}>
						  <p>{__t('Предпочитаният')}</p>
						  <h1>{__t('Хостингh')}</h1>
						  <h2>{__t('от над 200 000 уебсайта')}</h2>

						  <div className={styles.listContainer}>
							  <ul>
								  <li>{__t('Безкомпромисна поддръжка 24/7')}</li>
								  <li>{__t('Безплатно прехвърляне при нас и почистване на сайта')}</li>
								  <li>{__t('Защита срещу хакерски и DDoS атаки')}</li>
								  <li>{__t('Безплатни инструменти и още...')}</li>
							  </ul>
						  </div>
					  </div>
				  </div>
			  </div>
		  </header>
	  </>
	)
}

export default HostingHeader
